/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/063-coin-yen': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 13.5a6 6 0 110-12 6 6 0 010 12z"/><path pid="1" d="M9.5 9a.5.5 0 000-1H8.434l1.482-2.223a.5.5 0 10-.832-.554L7.5 7.599 5.916 5.223a.5.5 0 10-.832.554L6.566 8H5.5a.5.5 0 000 1H7v1H5.5a.5.5 0 000 1H7v1.5a.5.5 0 001 0V11h1.5a.5.5 0 000-1H8V9h1.5z"/>'
  }
})
